var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMoreOptions = function SvgMoreOptions(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8,
    d: "M11.727 16.455a4.727 4.727 0 1 1 0-9.455 4.727 4.727 0 0 1 0 9.455M11.727 31.91a4.727 4.727 0 1 1 0-9.455 4.727 4.727 0 0 1 0 9.454M31.91 11.727h-9.455M27.182 7v9.455M27.182 31.91a4.727 4.727 0 1 1 0-9.456 4.727 4.727 0 0 1 0 9.455"
  })));
};
export default SvgMoreOptions;